import { Font, StyleSheet } from '@react-pdf/renderer';
import { FONT_PATHS } from 'constants/fontPaths';

Font.register({
	family: 'Lato',
	fonts: [
		{ src: FONT_PATHS.LatoLight, fontStyle: 'normal', fontWeight: 'light' },
		{ src: FONT_PATHS.LatoRegular, fontStyle: 'normal', fontWeight: 'normal' },
		{ src: FONT_PATHS.LatoBold, fontStyle: 'normal', fontWeight: 'bold' },
	],
});

const Template1Styles = StyleSheet.create({
	document: {},
	page: {
		backgroundColor: '#F1F1F1',
		height: '100%',
		paddingVertical: '20px',
	},
	aboutbox: {
		padding: '10px 20px 20px',
		flexDirection: 'row',
		alignItems: 'center',
		gap: '35px',
		position: 'relative',
	},
	profileImgBox: {
		width: '162px',
		height: '162px',
		borderRadius: '162px',
		border: '2px solid #fff',
	},
	profileImg: {
		width: '158px',
		height: '158px',
		borderRadius: '160px',
		objectFit: 'cover',
	},
	aboutDetail: {
		flex: '1',
	},
	userName: {
		fontSize: '28px',
		color: '#707078',
		lineHeight: 'normal',
		fontWeight: 'normal',
		fontFamily: 'Lato',
		letterSpacing: '5px',
		textTransform: 'uppercase',
		marginBottom: '20px',
	},
	designation: {
		fontSize: '14px',
		color: '#707078',
		lineHeight: 'normal',
		fontWeight: 'normal',
		fontFamily: 'Lato',
		letterSpacing: '3.22px',
		textTransform: 'uppercase',
		marginBottom: '10px',
	},
	pageInfo: {
		flexDirection: 'row',
		borderTop: '1px solid #D9D9D9',
		// height: '100%',
		flex: 1,
	},
	left: {
		width: '210px',
		maxWidth: '210px',
		flex: 1,
		borderRight: '1px solid #D9D9D9',
	},
	right: {
		flex: '1',
		padding: '20px 15px',
		flexDirection: 'column',
		gap: '30px',
	},
	mainBox: {
		padding: '20px 15px',
		borderBottom: '1px solid #D9D9D9',
	},
	mainBoxInner: {
		flexDirection: 'column',
		gap: '12px',
	},
	detailBox: {
		flexDirection: 'row',
		alignItems: 'center',
		width: '100%',
		gap: '8px',
	},
	detailText: {
		fontSize: '10px',
		color: '#707078',
		lineHeight: 'normal',
		fontWeight: '600',
		fontFamily: 'Lato',
	},
	detailSubText: {
		fontSize: '8px',
		color: '#707078',
		lineHeight: 'normal',
		fontWeight: 'normal',
		fontFamily: 'Lato',
	},
	detailIcon: {
		width: '20px',
		height: '20px',
		objectFit: 'cover',
		objectPosition: 'center',
		borderRadius: '20px',
	},
	heading: {
		fontSize: '12px',
		color: '#707078',
		lineHeight: 'normal',
		marginBottom: '15px',
		fontWeight: 'bold',
		fontFamily: 'Lato',
		letterSpacing: '0.96px',
		textTransform: 'uppercase',
	},
	skills: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		gap: '5px',
	},
	skillsBox: {
		padding: '2px 5px',
		backgroundColor: '#E4E4E4',
	},
	skillsText: {
		fontSize: '8px',
		color: '#292A36',
		fontWeight: 'normal',
		fontFamily: 'Lato',
		letterSpacing: '0.16px',
		lineHeight: '1.5',
		textTransform: 'capitalize',
	},
	rightDetails: {
		flexDirection: 'column',
		gap: '15px',
	},
	title: {
		fontSize: '10px',
		color: '#292A36',
		lineHeight: 'normal',
		fontWeight: '600',
		fontFamily: 'Lato',
		letterSpacing: '0.4px',
		textTransform: 'capitalize',
		marginBottom: '3px',
	},
	urlBox: {
		flexDirection: 'row',
		gap: '5px',
		alignItems: 'center',
		marginBottom: '5px',
	},
	urlIcon: {
		width: '11px',
		height: '11px',
		objectFit: 'cover',
	},
	urlData: {
		fontSize: '8px',
		color: '#1200AA',
		lineHeight: 'normal',
		fontWeight: 'normal',
		fontFamily: 'Lato',
		letterSpacing: '0.48px',
	},
	awardRow: {
		flexDirection: 'row',
		gap: '8px',
		paddingRight: '30px',
	},
	awardIcon: {
		width: '26px',
		height: '26px',
		objectFit: 'cover',
		borderRadius: '26px',
	},
	experienceRow: {
		flexDirection: 'row',
		gap: '15px',
	},
	experienceContent: {
		flex: '1',
	},
	experienceDate: {
		fontSize: '10px',
		color: '#707078',
		lineHeight: 'normal',
		fontWeight: '600',
		fontFamily: 'Lato',
		textTransform: 'uppercase',
		width: '60px',
	},
	ListData: {
		flexDirection: 'row',
		gap: '5px',
		alignItems: 'center',
	},
	ListBox: {
		marginTop: '5px',
	},
	Listicon: {
		fontSize: '12px',
		color: '#707078',
		fontWeight: '600',
	},
	hobbies: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		gap: '7px',
	},
	hobbiesIcon: {
		width: '25px',
		height: '25px',
		borderRadius: '25px',
	},
});

export default Template1Styles;
